import { useEffect, useState, useContext, useCallback } from 'react';
import { Redirect } from 'react-router-dom';
import { appPaths, deleteContributionFromApi, getAllContributionsFromApi } from '../../helpers';

import Dropdown from '../../components/Dropdown';
import Loader from '../../components/Loader';
import DashboardItem from '../../components/DashboardItem';
import RevGenWelcomeModal from '../../components/modals/RevGenWelcomeModal';

import * as S from './styled';
import { API_Response } from '../../types';
import { AppContext } from '../../context/App';
import { getQueryArg } from '@wordpress/url';

const sortByDropdownOptions = [
	{value: 'desc', label: 'Newest first'},
	{value: 'asc', label: 'Oldest first'},
];

function Dashboard() {
	const {isWelcomeDone, hasContributions} = useContext(AppContext);
	const [loaded, setLoaded] = useState<boolean>(false);
	const [contributions, setContributions] = useState<API_Response[]>([]);
	const [searchString, setSearchString] = useState<string>('');
	const [order, setOrder] = useState<string>('desc');
	const {footerContribution, dispatchConfig} = useContext(AppContext);
	const updateConfig = useCallback((payload: {}) => {
		dispatchConfig({ payload });
	}, [dispatchConfig]);

	useEffect(() => {
		getAllContributionsFromApi().then(data => {
			setContributions(data.items);
			setLoaded(true);
		}).catch((error) => {
			setLoaded(true);
			updateConfig({ errorMessage: error.message });
		});
	}, [updateConfig]);

	function onItemDelete(item: API_Response) {
		deleteContributionFromApi(item.ID)
			.then((response) => {
				if (response.success) {
					const filtered = contributions.filter((contribution) => {
						return item.ID !== contribution.ID;
					});

					if (item.ID === footerContribution) {
						updateConfig({ footerContribution: 0 });
					}

					setContributions(filtered);
				}
			}).catch(() => {
				return false;
			});
	}

	function filterContributions(item: API_Response) {
		return item.post_title.toLowerCase().indexOf(searchString) !== -1;
	}

	function sortContributions(a: API_Response, b: API_Response) {
		if (order === 'asc') {
			return a.ID - b.ID;
		} else {
			return b.ID - a.ID;
		}
	}

	const items = contributions.filter(filterContributions).sort(sortContributions);

	return (
		<>
			{
				loaded &&
				getQueryArg(window.location.href, 'revGenWelcome') &&
				<RevGenWelcomeModal />
			}
			{!isWelcomeDone && <Redirect to={appPaths.welcome} />}
			{!hasContributions && <Redirect to={appPaths.builder} />}

			<Loader enabled={!loaded} />

			<S.GlobalStyle />

			<S.Header>
				<S.SortBy>
					<S.SortByLabel htmlFor="rgSortByDropdown">Sort by</S.SortByLabel>
					<Dropdown
						id="rgSortByDropdown"
						options={sortByDropdownOptions}
						onChange={setOrder}
					/>
				</S.SortBy>
				<S.SearchContainer>
					<S.SearchInput placeholder="Search Contributions" onChange={(e) => setSearchString(e.target.value.toLowerCase())} />
				</S.SearchContainer>
				<S.ButtonLink to="/contributions/builder">New Contribution</S.ButtonLink>
			</S.Header>
			<S.Contributions>
				{items.map((item, index) =>
					<DashboardItem
						key={item.ID}
						data={item}
						onDelete={() => onItemDelete(item)}
					/>
				)}

				{loaded && (!hasContributions || !items.length) &&
					<S.NotFoundContainer>
						<S.NotFoundTitle>No Contribution matched your search.<br />Try again or</S.NotFoundTitle>
						<S.ButtonLink tall to="/contributions/builder">Create a new Contribution</S.ButtonLink>
					</S.NotFoundContainer>
				}
			</S.Contributions>
		</>
	)
}

export default Dashboard;
